import { render, staticRenderFns } from "./NewsWidgetContent.vue?vue&type=template&id=50b59127"
import script from "./NewsWidgetContent.vue?vue&type=script&lang=js"
export * from "./NewsWidgetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports